import React from 'react';
import { colors } from '@alixpartners/ui-components';

const LongArrowIcon = () => (
  <svg
    width="82"
    height="24"
    viewBox="0 0 82 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.939339 10.9393C0.353554 11.5251 0.353554 12.4749 0.939339 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51471C13.1924 2.92893 13.1924 1.97918 12.6066 1.39339C12.0208 0.807605 11.0711 0.807605 10.4853 1.39339L0.939339 10.9393ZM82 10.5L2 10.5L2 13.5L82 13.5L82 10.5Z"
      fill={colors.amber}
    />
  </svg>
);

export default LongArrowIcon;
